import React from 'react';
import { motion } from 'framer-motion';
import { Handshake } from '@phosphor-icons/react';
import { useLanguage } from '../context/LanguageContext';
import { companyInfo } from '../i18n/translations';

export const PartnersSection = () => {
  const { t } = useLanguage();

  return (
    <section id="partners" className="py-24 lg:py-32 bg-white" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-[#FF6B00] text-xs sm:text-sm font-medium uppercase tracking-[0.2em] mb-4 flex items-center justify-center gap-2">
            <Handshake size={16} weight="bold" />
            {t.partners_section.title}
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1320] tracking-tight"
            style={{ fontFamily: "'Playfair Display', 'Cabinet Grotesk', serif" }}
            data-testid="partners-title"
          >
            {t.partners_section.title}
          </h2>
          <p className="text-base text-[#475569] mt-4 max-w-xl mx-auto" style={{ fontFamily: "'Inter', 'Manrope', sans-serif" }}>
            {t.partners_section.subtitle}
          </p>
        </motion.div>

        {/* Partners Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {companyInfo.partners.map((partner, index) => (
            <motion.div
              key={partner}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-[#F8FAFC] border border-[#E2E8F0] hover:border-[#FF6B00]/30 transition-colors p-8 flex flex-col items-center justify-center text-center group"
            >
              <div className="w-16 h-16 bg-[#0B1320] flex items-center justify-center mb-5 group-hover:bg-[#FF6B00] transition-colors">
                <Handshake size={28} className="text-white" weight="bold" />
              </div>
              <h3
                className="text-lg font-semibold text-[#0B1320] tracking-tight"
                style={{ fontFamily: "'Playfair Display', 'Cabinet Grotesk', serif" }}
              >
                {partner}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
